module.exports = __webpack_public_path__ + "img/shion yorigami_lw.be9cfd8d.png";